// Formatação compartilhada pelas telas da área administrativa

export const ESTADOS = {
  trial:   { label: 'Teste grátis', bg: '#fff4e5', text: '#a15c00', dot: '#f59e0b' },
  active:  { label: 'Ativa',        bg: '#e7f7ee', text: '#15803d', dot: '#22c55e' },
  expired: { label: 'Vencida',      bg: '#fdecec', text: '#b91c1c', dot: '#ef4444' },
  legacy:  { label: 'Legado',       bg: '#f3f4f6', text: '#4b5563', dot: '#9ca3af' },
};

export const PAGAMENTOS = {
  PENDING:  { label: 'Aguardando', bg: '#fff4e5', text: '#a15c00', dot: '#f59e0b' },
  APPROVED: { label: 'Pago',       bg: '#e7f7ee', text: '#15803d', dot: '#22c55e' },
  REJECTED: { label: 'Recusado',   bg: '#fdecec', text: '#b91c1c', dot: '#ef4444' },
  EXPIRED:  { label: 'Expirado',   bg: '#f3f4f6', text: '#6b7280', dot: '#9ca3af' },
};

export const NIVEIS = { adm: 'Administrador', user: 'Usuário', operador: 'Operador' };

export function badgeEstado(state) {
  const e = ESTADOS[state] ?? ESTADOS.legacy;
  return { type: 'badge', label: e.label, bg: e.bg, text: e.text, dot: e.dot };
}

export function badgePagamento(status) {
  const p = PAGAMENTOS[status] ?? PAGAMENTOS.EXPIRED;
  return { type: 'badge', label: p.label, bg: p.bg, text: p.text, dot: p.dot };
}

export function data(valor) {
  return valor ? new Date(valor).toLocaleDateString('pt-BR') : '—';
}

export function dataHora(valor) {
  return valor ? new Date(valor).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }) : '—';
}

export function money(valor) {
  return Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function periodo(meses) {
  if (meses === 1) return '1 mês';
  if (meses === 12) return '1 ano';
  return meses + ' meses';
}

// Até quando a empresa tem acesso, conforme a situação
export function vencimento(t) {
  if (t.state === 'trial') return 'Teste até ' + data(t.trial_ends_at);
  if (t.state === 'active') return 'Pago até ' + data(t.paid_until);
  if (t.state === 'expired') return 'Venceu em ' + data(t.paid_until || t.trial_ends_at);
  return 'Sem vencimento';
}

export function whatsappLink(numero) {
  const digitos = String(numero || '').replace(/\D/g, '');
  if (!digitos) return null;
  return 'https://wa.me/' + (digitos.length <= 11 ? '55' + digitos : digitos);
}
